export function getLeftMenuDataUser() {
  // 左選單
  return [
    {
      title: 'Dashboard',
      key: 'dashboard',
      icon: 'icmn icmn-home',
      url: '/dashboard',
    },
    {
      divider: true,
    },
    {
      title: '病歷管理',
      key: 'patients-menu',
      icon: 'icmn icmn-profile',
      children: [
        {
          title: '填寫',
          key: 'patients-form',
          url: '/patients-form',
        },
        {
          title: '初診病歷表',
          key: 'patients',
          url: '/patients',
        },
        {
          title: '治療計劃表',
          key: 'projs',
          url: '/patients/find',
        },
      ],
    },
    {
      title: '評價管理',
      key: 'comments',
      icon: 'icmn icmn-menu',
      children: [
        {
          title: '評價',
          key: 'comments',
          url: '/comments',
        },
        {
          title: '評價統計',
          key: 'comments-stats',
          url: '/comments/stats',
        },
      ],
    },
    /*    {
      title: 'Line約診',
      key: 'resvs',
      icon: 'icmn icmn-file-text',
      url: '/resvs',
    }, */
    {
      title: '診所管理',
      key: 'settings',
      icon: 'icmn icmn-cog',
      children: [
        {
          title: '牙材',
          key: 'mats',
          url: '/mats',
        },
        {
          title: '治療項目',
          key: 'cures',
          url: '/cures',
        },
        {
          title: '醫師',
          key: 'cdrs',
          url: '/cdrs',
        },
      ],
    },
    {
      title: '診所報表',
      key: 'reports',
      icon: 'icmn icmn-table',
      children: [
        {
          title: '明細帳',
          key: 'transDetails',
          url: '/trans/details',
        },
        {
          title: '牙材耗用明細',
          key: 'usedDetails',
          url: '/used/details',
        },
        {
          title: '醫師薪資報表',
          key: 'transStat',
          url: '/trans/stat',
        },
      ],
    },
  ]
}
export function getTopMenuDataUser() {
  // 上選單
  return []
}
